module.exports = __webpack_public_path__ + "img/ico_menu.9e64162b.svg";